import React from 'react';
import styled from 'styled-components';
import { generatePath } from 'react-router';
import { Heading, Link, Paragraph } from 'components/atoms';
import { Routes } from 'constants/index';
import { getPath } from 'utils';

interface Props {
  subtopicName?: string;
  topicName?: string;
  categoryName?: string;
}

export const NoResults: React.FC<Props> = ({ subtopicName, topicName, categoryName }) => {
  return (
    <StyledMessagePlaceholder>
      <StyledHeading>Sorry, nothing matches all of your criteria</StyledHeading>
      {categoryName && (
        <StyledParagraph>
          More {subtopicName ? subtopicName : topicName}&nbsp;{categoryName} will be released in the future.
        </StyledParagraph>
      )}
      <StyledParagraph>
        Try using the&nbsp;
        <Link testId="search-page" to={`${generatePath(getPath(Routes.SEARCH))}?`}>
          Search page
        </Link>
        &nbsp;if you’re looking for something in particular.
      </StyledParagraph>
    </StyledMessagePlaceholder>
  );
};

const StyledMessagePlaceholder = styled.div`
  height: ${props => props.theme.pxToRem(300)};
  padding-top: ${props => props.theme.pxToRem(64)};
  margin-bottom: ${props => props.theme.pxToRem(40)};
`;

const StyledHeading = styled(Heading)`
  &&&&& {
    font-size: ${props => props.theme.fontSizes.xl};
    font-weight: ${props => props.theme.fontWeights.light};
    line-height: 1.38;
    max-width: ${props => props.theme.pxToRem(621)};
    color: ${props => props.theme.colors.neutralGrey8};
  }
`;

const StyledParagraph = styled(Paragraph)`
  font-size: ${props => props.theme.fontSizes.xs};
  font-weight: ${props => props.theme.fontWeights.light};
  max-width: ${props => props.theme.pxToRem(411)};
  color: ${props => props.theme.colors.neutralGrey8};
  line-height: 1.57;
  :not(:last-of-type) {
    margin-bottom: ${props => props.theme.pxToRem(22)};
  }
`;
